'use client';

import { useContext } from 'react';
import { ServerLanguageContext } from './LanguageContext';

export function useServerLanguage() {
  const lang = useContext(ServerLanguageContext);

  return {
    serverLanguage: lang,
  };
}
